import { CardVariant } from "../../../models/CardVariant";
import { CardFilterCommands } from "../CardFilterCommands";
import { IFilterCommand } from "../IFilterCommand";

export type FullArtFilterArgs = {
    excludePromos: boolean
}

export class FullArtFilter<TItem extends CardVariant> implements IFilterCommand<TItem, FullArtFilterArgs> {
    isMatch(item: TItem, filters: FullArtFilterArgs = { excludePromos: false }): boolean {
        if (!item?.variant) {
            return false;
        }

        const isFullArt = item.variant.toLowerCase().includes("full art");
        return filters.excludePromos
            ? isFullArt && !CardFilterCommands.promo.isMatch(item)
            : isFullArt;
    }
}